import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { UserAuth } from '../context/AuthContext';
import {
  Box,
  Button,
  Center,
  Heading,
  Text,
  VStack,
  Icon,
  Flex,
} from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';

const Welcome = () => {
  const { session } = UserAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (session) {
      const timer = setTimeout(() => navigate('/Agent-Generation'), 5000);
      return () => clearTimeout(timer);
    }
  }, [session]);

  return (
    <Center mt="20">
      <Box maxW="md" p={6} textAlign="center">
        <Flex
          w={16}
          h={16}
          bg="green.100"
          rounded="full"
          align="center"
          justify="center"
          mx="auto"
          mb={4}
        >
          <Icon as={CheckIcon} w={8} h={8} color="green.600" />
        </Flex>
        <Heading as="h1" size="lg" mb={4}>
          Email Verified!
        </Heading>
        <Text mb={6}>
          Thank you for verifying{' '}
          <Text as="span" fontWeight="semibold">
            {session?.user?.email}
          </Text>
          . You'll be redirected shortly.
        </Text>
        <Button
          onClick={() => navigate('/dashboard')}
          px={6}
          py={2}
          bg="blue.600"
          color="white"
          _hover={{ bg: 'blue.700' }}
          rounded="md"
        >
          Go to Dashboard Now
        </Button>
      </Box>
    </Center>
  );
};

export default Welcome;
